/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import OnlyOneOption from '../../components/onlyOneOption';
import steps from '../../survey/steps';
import s from './index.module.scss';
import defaultOption from '../styles/defaultOption.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import optionsImagesMan from '../../surveyMan/optionsImagesMan';
import questionsMan from '../../surveyMan/questionsMan';
import questionsMethods from '../../survey/questions';

function DefaultQuestion (props) {
	const { T } = useT();
	const { options } = props.step;
	const { name } = props.step;
	const gender = props.questionsType.getAnswers({ questionName: 'gender' }).value;
	const imgAtRightSide = props.design ? defaultOption.imgAtRightSide : '';

	function actionOnClick () {
		setTimeout(() => {
			steps.navigate.forward({
				preventAction: 500
			});
		}, 300);

		if (props.planMan && props.questionsType.isAnswerSelected({ questionName: 'muscle_focus', answer: 'yes' })) {
			props.questionsType.addOnlyAnswer({
				questionName: 'muscle_focus',
				answer: 'yes'
			});
		}
	}

	return (
		<section className={`${common.step}`}>
			<div className={common.stepTitle}>{T(name)}</div>
			<div className={common.stepDescription}>{T(`${name}_description`)}</div>

			<div className={s.options}>
				{
					options && Object.entries(options).map((option) => {
						let imgSrc;
						if (props.optionsImagesType[name]) imgSrc = (gender && gender !== 'female' && props.optionsImagesType[name][gender]) ? props.optionsImagesType[name][gender][option[1].value] : props.optionsImagesType[name][option[1].value];
						const withDescription = option[1].description;

						return (
							<OnlyOneOption
								key={option[1].value}
								className={`${defaultOption.option} ${s.optionWithArrow} ${withDescription ? s.withDescription : ''} ${props.isExpandedDesign} ${imgAtRightSide}`}
								selectedStateClass={s.optionWithArrowSelected}
								option={option[1]}
								questionName={name}
								actionOnClick={actionOnClick}
								disableFromFocus={!props.isThisCurrentStep}
								runOnChoose={() => { steps.userMovedToNextStepByClick({ byNextStep: true }); }}
								design={props.design}
							>
								{imgSrc && (
									<div className={defaultOption.iconWrapper}>
										<img className={defaultOption.icon} src={imgSrc} alt="" />
									</div>
								)}
								{!withDescription && T(`${name}_${option[1].value}`)}
								{withDescription &&
                  (
                  	<div>
                  		<div className={`${option[1].design === 'smallTitleWithDescription' ? '' : s.title}`}>
                  			{T(`${name}_${option[1].value}`)}
                  			{option[1].design === 'titleWithLabel' ? <div className={s.optionLabel}>{T('frequency_label_recommended')}</div> : ''}
                  		</div>
                  		<div className={s.description}>{T(`${name}_${option[1].description}`)}</div>
                  	</div>
                  )}
							</OnlyOneOption>
						);
					})
				}
			</div>
		</section>
	);
}

function WithOneOption (props) {
	const questions = useSelector((state) => state.questions.list);
	const questionName = props.stepData.name;
	const question = questions[questionName];
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const isExpandedDesign = props.isExpandedDesign ? s.designExpanded : '';
	const planMan = useSelector((state) => state.global.planMan);
	const optionsImagesType = planMan ? optionsImagesMan : optionsImages;
	const questionsType = planMan ? questionsMan : questionsMethods;

	return (
		<div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<DefaultQuestion
				design={props.design}
				step={question}
				index={1}
				isThisCurrentStep={isThisCurrentStep}
				isExpandedDesign={isExpandedDesign}
				optionsImagesType={optionsImagesType}
				questionsType={questionsType}
				planMan={planMan}
			/>
		</div>
	);
}

export default WithOneOption;
